import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import { pick } from 'lodash-es';
import { orderBy } from 'lodash-es';
import { filter } from 'lodash-es';
import { useCntfContent } from '~/composables/useCntfContent';
var DEFAULT_ICONS_LIBRARIES = /*#__PURE__*/function (DEFAULT_ICONS_LIBRARIES) {
  /** @member {string} */
  /** Type de cheveux */
  DEFAULT_ICONS_LIBRARIES[DEFAULT_ICONS_LIBRARIES["libraryHairTypeIcon"] = 0] = "libraryHairTypeIcon";
  /** @member {string} */
  /** Univers olfactif */
  DEFAULT_ICONS_LIBRARIES[DEFAULT_ICONS_LIBRARIES["iconLibraryOlfactoryFamily"] = 1] = "iconLibraryOlfactoryFamily";
  /** @member {string} */
  /** Propriété */
  DEFAULT_ICONS_LIBRARIES[DEFAULT_ICONS_LIBRARIES["iconLibraryProductEoGuideBenefit"] = 2] = "iconLibraryProductEoGuideBenefit";
  /** @member {string} */
  /** Bienfait propriété */
  DEFAULT_ICONS_LIBRARIES[DEFAULT_ICONS_LIBRARIES["iconLibraryRecipeBenefit"] = 3] = "iconLibraryRecipeBenefit";
  /** @member {string} */
  /** Type de peaux */
  DEFAULT_ICONS_LIBRARIES[DEFAULT_ICONS_LIBRARIES["iconLibrarySkin"] = 4] = "iconLibrarySkin";
  return DEFAULT_ICONS_LIBRARIES;
}(DEFAULT_ICONS_LIBRARIES || {});
var NEEDED_KEYS = ['adaptedForV2', 'specificProblemsV2', 'beneficialPropertiesV2', 'skinTypeV2', 'hairTypeV2', 'selection', 'galenicFamily', 'type-de-cheveux', 'type-de-peaux', 'univers-olfactif', 'proprietes-beaute', 'proprietes-bien-etre'];
export default function (_ref) {
  var keyBenefitsAttributes = _ref.keyBenefitsAttributes,
    _ref$iconsLibraries = _ref.iconsLibraries,
    iconsLibraries = _ref$iconsLibraries === void 0 ? DEFAULT_ICONS_LIBRARIES : _ref$iconsLibraries;
  var _useCntfContent = useCntfContent('keyBenefits'),
    search = _useCntfContent.search,
    content = _useCntfContent.content,
    loading = _useCntfContent.loading,
    error = _useCntfContent.error;
  function simplifyAttribute(attribute) {
    var _attribute$fields;
    if (_typeof(attribute) === 'object' && (_attribute$fields = attribute.fields) !== null && _attribute$fields !== void 0 && _attribute$fields.attributeName) {
      var _attribute$fields2;
      return (_attribute$fields2 = attribute.fields) === null || _attribute$fields2 === void 0 ? void 0 : _attribute$fields2.attributeName;
    } else if (typeof attribute === 'string') {
      return attribute;
    }
  }
  var allAttributes = computed(function () {
    var attributesObj = pick(keyBenefitsAttributes.value, NEEDED_KEYS);
    var attributesArray = Object.values(attributesObj).flat();
    return attributesArray.map(simplifyAttribute);
  });
  var sortedIcons = computed(function () {
    var sortByTitle = function sortByTitle(_ref2) {
      var _fields$attributeName;
      var fields = _ref2.fields;
      return fields === null || fields === void 0 ? void 0 : (_fields$attributeName = fields.attributeName) === null || _fields$attributeName === void 0 ? void 0 : _fields$attributeName.toUpperCase();
    };
    var sortByCategory = function sortByCategory(_ref3) {
      var sys = _ref3.sys;
      return iconsLibraries[sys.contentType.sys.id];
    };
    return orderBy(content.value, [sortByCategory, sortByTitle], ['asc', 'asc']);
  });
  var keyBenefits = computed(function () {
    var _sortedIcons$value, _sortedIcons$value$fi, _sortedIcons$value$fi2;
    return (_sortedIcons$value = sortedIcons.value) === null || _sortedIcons$value === void 0 ? void 0 : (_sortedIcons$value$fi = _sortedIcons$value.filter(function (obj) {
      return obj === null || obj === void 0 ? void 0 : obj.fields;
    })) === null || _sortedIcons$value$fi === void 0 ? void 0 : (_sortedIcons$value$fi2 = _sortedIcons$value$fi.filter(function (_ref4) {
      var fields = _ref4.fields;
      return allAttributes.value.includes(fields.attributeName);
    })) === null || _sortedIcons$value$fi2 === void 0 ? void 0 : _sortedIcons$value$fi2.slice(0, 10);
  });
  useLazyAsyncData('composable-useKeyBenefits', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return search({
            'sys.contentType.sys.id[in]': String(filter(Object.keys(iconsLibraries), isNaN))
          });
        case 2:
          return _context.abrupt("return", true);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return {
    keyBenefits: keyBenefits,
    loading: loading,
    error: error
  };
}